import axios from 'axios';

var axiosPublicIAInstance = axios.create();
axiosPublicIAInstance.defaults.baseURL = process.env.REACT_APP_BASE_AI_URL;
axiosPublicIAInstance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosPublicIAInstance.interceptors.response.use(
  function (response) {
    if (response && Object.keys(response).length > 0) return response;
    else return Promise.reject(new Error('Empty response'));
  },
  function (error) {
    if (error.response.status === 404) {
      return Promise.reject(
        new Error(error.response.data.message || error.response.data.error || 'Unexpected error')
      );
    }
    if (error.response.status === 400 || error.response.status === 402) {
      return Promise.reject(
        new Error(error.response.data.error || error.response.data.message || error)
      );
    } else return Promise.reject(error);
  }
);

export default axiosPublicIAInstance;
